/* APP COMPONENT **************************************************************/

/* react redux */
import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { translate } from 'react-i18next'

import { fetchCookieOptIn, saveCookieOptIn } from 'react-redux/actions/app'

import selector from './selector'

/* Components */

class CookieOptIn extends Component {

  componentWillMount() {
    const { fetchCookieOptIn } = this.props
    //const { applicationStartup } = this.props
    //applicationStartup()
    fetchCookieOptIn()
  }

  allowCookie() {
    const { saveCookieOptIn } = this.props
    saveCookieOptIn(true)
  }

  //
  render() {
    const { t, cookieAllowed } = this.props
    if( !cookieAllowed ) return (
      <div className="cookie-opt-in">
        <span className="cookie-message">
          { t("user:login.cookieMessage") }
        </span>
        <button
          className="action"
          onClick={ this.allowCookie.bind(this) }
        >
          {t("user:login.allowCookie")}
        </button>
      </div>
    )
    return null
  }
}

CookieOptIn.propTypes = {}

const mapStateToProps = (state) => selector(state)

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
      {
        fetchCookieOptIn,
        saveCookieOptIn,
        //showModal,
        //applicationStartup,
        //allowCookie,
        //setView
      },
      dispatch
    )
}

const reduxComponent = connect(mapStateToProps, mapDispatchToProps)(CookieOptIn)
export default translate([], { withRef: true })(reduxComponent)



// WEBPACK FOOTER //
// ./src/app/component/cookie-opt-in/index.jsx